import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import { isChrome, isFirefox, isIeEdge } from "@tightrope/lpscripts/browserdetect";
import Styles from "./css/disclaimers.module.scss";
let Disclaimers = /*#__PURE__*/function (_React$Component) {
  function Disclaimers(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      data: {},
      language: {}
    };
    return _this;
  }
  _inheritsLoose(Disclaimers, _React$Component);
  var _proto = Disclaimers.prototype;
  _proto.componentDidMount = function componentDidMount() {
    if (this.props && this.props.data) {
      this.props.data.then(data => {
        this.setState({
          data: data
        });
        this.setState({
          language: this.props.language
        });
      });
    }
  };
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", {
      id: Styles.disclaimers
    }, this.props.children, (() => {
      switch (this.props.language) {
        case 'en-chrome':
          return /*#__PURE__*/React.createElement("p", null, "This free extension will update this browser's new tab page. By continuing, you acknowledge the ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "Terms of Service"), " and ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "Privacy Policy"), ", and that you may be presented with more optional offers.");
          break;
        case 'en-firefox':
          return /*#__PURE__*/React.createElement("p", null, "This free extension will update this browser's search settings. By continuing, you acknowledge the ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "Privacy Policy"), " and ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "Terms of Service"), ", and that you may be presented with more optional offers.");
          break;
        case 'en-edge':
          return /*#__PURE__*/React.createElement("p", null, "This free extension will update this browser's new tab page. By continuing, you acknowledge the ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "Terms of Service"), " and ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "Privacy Policy"), ", and that you may be presented with more optional offers.");
          break;
        case 'en-safari':
          return /*#__PURE__*/React.createElement("p", null, "This free extension will update this browser's new tab page. By continuing, you acknowledge the ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "Terms of Service"), " and ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "Privacy Policy"), ", and that you may be presented with more optional offers.");
          break;
        case 'en-clear-chrome':
          return /*#__PURE__*/React.createElement("p", null, "By clicking above, you agree to the ", /*#__PURE__*/React.createElement("a", {
            href: "https://clearbar.app/terms-of-service/",
            target: "_blank"
          }, "Terms of Service"), " and ", /*#__PURE__*/React.createElement("a", {
            href: "https://clearbar.app/privacy-policy/",
            target: "_blank"
          }, "Privacy Policy"), " for Clear, a Chromium based browser with web search results provided by Yahoo!");
          break;
        case 'en-clear-edge':
          return /*#__PURE__*/React.createElement("p", null, "By clicking above, you agree to the ", /*#__PURE__*/React.createElement("a", {
            href: "https://clearbar.app/terms-of-service/",
            target: "_blank"
          }, "Terms of Service"), " and ", /*#__PURE__*/React.createElement("a", {
            href: "https://clearbar.app/privacy-policy/",
            target: "_blank"
          }, "Privacy Policy"), " for Clear, a Chromium based browser with web search results provided by Yahoo!");
          break;
        case 'de-chrome':
          return /*#__PURE__*/React.createElement("p", null, "Diese kostenlose Erweiterung aktualisiert die Sucheinstellungen dieses Browsers. Wenn Sie fortfahren, best\xE4tigen die Nutzungsbedingungen  ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "Nutzungsbedingungen"), " und ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "Datenschutzerkl\xE4rung"), ", und dass Ihnen weitere optionale Angebote unterbreitet werden k\xF6nnen.");
          break;
        case 'de-firefox':
          return /*#__PURE__*/React.createElement("p", null, "Diese kostenlose Erweiterung aktualisiert die Sucheinstellungen dieses Browsers. Wenn Sie fortfahren, best\xE4tigen die ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "Nutzungsbedingungen"), " und ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "Datenschutzerkl\xE4rung"), " und kann mit zus\xE4tzlichen Angeboten vorgestellt werden.");
          break;
        case 'de-edge':
          return /*#__PURE__*/React.createElement("p", null, "Diese kostenlose Erweiterung aktualisiert die Sucheinstellungen dieses Browsers. Wenn Sie fortfahren, best\xE4tigen die Nutzungsbedingungen  ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "Nutzungsbedingungen"), " und ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "Datenschutzerkl\xE4rung"), ", und dass Ihnen weitere optionale Angebote unterbreitet werden k\xF6nnen.");
          break;
        case 'de-safari':
          return /*#__PURE__*/React.createElement("p", null, "Diese kostenlose Erweiterung aktualisiert die Sucheinstellungen dieses Browsers. Wenn Sie fortfahren, best\xE4tigen die Nutzungsbedingungen  ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "Nutzungsbedingungen"), " und ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "Datenschutzerkl\xE4rung"), ", und dass Ihnen weitere optionale Angebote unterbreitet werden k\xF6nnen.");
          break;
        case 'fr-chrome':
          return /*#__PURE__*/React.createElement("p", null, "Cette extension gratuite mettra \xE0 jour les param\xE8tres de recherche de ce navigateur. En continuant, vous reconnaissez la   ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "politique de confidentialit\xE9 "), " et las ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "conditions de service"), ", et le fait que d'autres offres facultatives peuvent vous \xEAtre pr\xE9sent\xE9es.");
          break;
        case 'fr-firefox':
          return /*#__PURE__*/React.createElement("p", null, "Cette extension gratuite mettra \xE0 jour les param\xE8tres de recherche de ce navigateur. En continuant, vous reconnaissez la   ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "politique de confidentialit\xE9 "), " et las ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "conditions de service"), ", et le fait que d'autres offres facultatives peuvent vous \xEAtre pr\xE9sent\xE9es.");
          break;
        case 'fr-edge':
          return /*#__PURE__*/React.createElement("p", null, "Cette extension gratuite mettra \xE0 jour les param\xE8tres de recherche de ce navigateur. En continuant, vous reconnaissez la   ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "politique de confidentialit\xE9 "), " et las ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "conditions de service"), ", et le fait que d'autres offres facultatives peuvent vous \xEAtre pr\xE9sent\xE9es.");
          break;
        case 'fr-safari':
          return /*#__PURE__*/React.createElement("p", null, "Cette extension gratuite mettra \xE0 jour les param\xE8tres de recherche de ce navigateur. En continuant, vous reconnaissez la   ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "politique de confidentialit\xE9 "), " et las ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "conditions de service"), ", et le fait que d'autres offres facultatives peuvent vous \xEAtre pr\xE9sent\xE9es.");
          break;
        case 'it-chrome':
          return /*#__PURE__*/React.createElement("p", null, "Questa estensione gratuita aggiorner\xE0 le impostazioni di ricerca di questo browser. Continuando, riconosci i ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "Termini di servizio"), " e ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "l'Informativa sulla privacy"), " e ti potrebbero essere presentate ulteriori offerte facoltative.");
          break;
        case 'it-firefox':
          return /*#__PURE__*/React.createElement("p", null, "Questa estensione gratuita aggiorner\xE0 le impostazioni di ricerca di questo browser. Continuando, accetti i ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "Termini di servizio"), ", ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "l'Informativa sulla privacy"), " e che ti potrebbero essere presentate ulteriori offerte facoltative.");
          break;
        case 'it-edge':
          return /*#__PURE__*/React.createElement("p", null, "Questa estensione gratuita aggiorner\xE0 le impostazioni di ricerca di questo browser. Continuando, riconosci i ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "Termini di servizio"), " e ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "l'Informativa sulla privacy"), " e ti potrebbero essere presentate ulteriori offerte facoltative.");
          break;
        case 'it-safari':
          return /*#__PURE__*/React.createElement("p", null, "Questa estensione gratuita aggiorner\xE0 le impostazioni di ricerca di questo browser. Continuando, riconosci i ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "Termini di servizio"), " e ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "l'Informativa sulla privacy"), " e ti potrebbero essere presentate ulteriori offerte facoltative.");
          break;
        default:
          return /*#__PURE__*/React.createElement("p", null, "This free extension will update this browser's search settings. By continuing, you acknowledge the ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank"
          }, "Privacy Policy"), " and ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank"
          }, "Terms of Service"), ", and that you may be presented with more optional offers.");
      }
    })());
  };
  return Disclaimers;
}(React.Component);
export default Disclaimers;